import React, { FC, useEffect } from 'react';
import { AddInStorage } from '../../storage/AddInStorage';

const css = require('./Login.module.scss');

const LogoutCallback: FC = () => {
    useEffect(() => {
        AddInStorage.clear();
        Office.context.ui.messageParent(JSON.stringify({ status: 'success', data: 'User has been signed out successfully.' }));
    }, []);
    return <>
        <div className={css.container}>
            <div className={css.content} style={{ paddingTop: 50 }}>
                <div className={css.fvidLoginBox} style={{ height: 250 }}>
                    <img
                      alt="Filevine"
                      height="45"
                      src="/assets/fv-logo.svg"
                      style={{ marginLeft: 50, marginBottom: 30 }}
                    />
                    <div style={{ padding: 30 }}>
                        <p>You have been signed out. You may now close this dialog.</p>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default LogoutCallback;